import { Suspense } from 'react';
import { ErrorBanner } from '@/components/error-page/error-banner';
import { SeoHandle } from '../sitemap[.]xml/generate-sitemap';
import { tournamentSitemap } from './sitemap';
import { TournamentOverview } from './tournament-overview';

export const handle: SeoHandle = {
  sitemap: tournamentSitemap,
};

export const ErrorBoundary = ErrorBanner;

export default function TournamentOverviewPage() {
  return (
    <Suspense fallback={null}>
      <TournamentOverview />
    </Suspense>
  );
}
